<script>
    import {_} from '../lib/i18n';
    let now = new Date();

    export let language;
</script>

<style>
    .payment_systems {
        margin-top: 5px;
    }
    .payment_systems img {
        margin-right: 10px;
    }

    .footer__logo-img svg {
        width: 100px;
        padding-right: 15px;
    }
    .row-flex {
        flex-direction: row;
    }
    .column-flex {
        flex-direction: column;
    }
    .footer__links-wrapper.right {
        margin-left: 15px;
    }
</style>

<footer class="footer">
    <div class="container">
        <div class="footer__copywrite-wrapper">
            <a href="/" class="footer__logo-wrapper">
                <div class="footer__logo-img">
                    {#if language === 'ru-RU'}
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="34" viewBox="0 0 36 34" fill="none">
                            <path d="M35.5 17.6365V15.5171L32.6755 15.5171C32.385 12.2569 31.2195 2.84343 27.254 0.540408C26.3895 0.0352964 24.972 -0.370912 23.1485 0.547472C22.809 0.720552 21.759 1.31044 20.0265 2.303L23.0971 4.01658C23.2183 4.08421 23.325 4.17543 23.411 4.28495C23.4971 4.39446 23.5607 4.52011 23.5983 4.65462C23.6359 4.78913 23.6467 4.92983 23.6301 5.06857C23.6134 5.20731 23.5697 5.34135 23.5014 5.46292C23.3651 5.70592 23.139 5.88457 22.8725 5.95977C22.606 6.03498 22.3209 6.00064 22.0795 5.86425C19.6009 4.46365 12.8874 0.6712 12.645 0.547448C10.8215 -0.370937 9.404 0.0352716 8.5395 0.540383C4.574 2.84341 3.40853 12.2568 3.118 15.5171H0.5V17.6365H35.5Z" fill="#595866"></path>
                            <path d="M22.4844 21.5951C23.6798 20.6702 25.1435 20.1677 26.6498 20.1653C27.9814 20.1648 29.2843 20.5559 30.3993 21.2906C31.5143 22.0253 32.3931 23.0719 32.9283 24.3024C33.4635 25.533 33.6319 26.8943 33.413 28.2199C33.1941 29.5455 32.5973 30.778 31.6956 31.7669C30.7939 32.7558 29.6262 33.4582 28.3354 33.7882C27.0445 34.1182 25.6864 34.0617 24.4269 33.6254C23.1674 33.1891 22.0611 32.392 21.2432 31.3315C20.4253 30.271 19.9312 28.993 19.8213 27.6537C19.2999 27.1784 18.6184 26.9218 17.916 26.9363C17.2135 26.9507 16.543 27.2351 16.0413 27.7314C15.884 29.4471 15.0959 31.0412 13.8321 32.1997C12.5683 33.3582 10.9204 33.9971 9.21315 33.9905C7.50585 33.9839 5.86288 33.3324 4.60788 32.1642C3.35288 30.9959 2.57684 29.3958 2.43263 27.6789C2.28842 25.962 2.78649 24.2529 3.82872 22.8881C4.87096 21.5234 6.38181 20.602 8.06365 20.3055C9.74549 20.009 11.4764 20.3588 12.9154 21.2861C14.3544 22.2133 15.3972 23.6508 15.8383 25.3153C16.4912 24.9947 17.2069 24.8254 17.933 24.8199C18.6591 24.8144 19.3772 24.9728 20.0348 25.2835C20.4282 23.8161 21.289 22.52 22.4844 21.5951Z" fill="#595866"></path>
                        </svg>
                    {:else}
                        <img src={$_('header.logoSmall')} />
                    {/if}
                </div>
            </a>
            <div class="footer__copywrite-text" style="display: block">
                <a class="footer__copywrite-link" href={`tel:${$_('footer.contactNumber')}`}>{$_('footer.contactNumberString')}</a> <br />
                © 2011-{now.getFullYear()}, {$_('footer.serviceName')} <br />
                {@html $_('footer.contactAddress')} <br />
                <div class="payment_systems">
                    <img src="/img/icons/master_card.svg" alt="master_card">
                    <img src="/img/icons/visa.svg" alt="visa">
                    {#if language === 'ru-RU'}
                        <img src="/img/icons/mir.svg" alt="mir">
                    {/if}
                </div>
            </div>
        </div>
        <div class="footer__links-wrapper column-flex">
            {#if (window.language === 'ru-RU')}
                <a href={$_('main.privacyLink')} target="_blank" class="footer__link">{$_('footer.privacyRules')}</a>
                <a href={$_('main.termsLink')} target="_blank" class="footer__link">{$_('footer.userTerms')}</a>
            {:else}
                <div class="footer__links-wrapper left">
                    <a href="/terms" target="_blank" class="footer__link">{$_('footer.userTerms')}</a>
                    <a href="/privacy-policy" target="_blank" class="footer__link">{$_('footer.privacyRules')}</a>
                    <a href="/refund-policy" target="_blank" class="footer__link">{$_('footer.refundPolicy')}</a>
                </div>
                {#if (window.language !== 'ru-RU')}
                    <div class="footer__links-wrapper right">
                        <a href="#" class="footer__link" on:click|preventDefault|stopPropagation={(e) => { OmniWidgetApi.call('open_widget'); }}>14-days money-back</a>
                    </div>
                {/if}
            {/if}
        </div>



        <div class="footer__disclaimer">
            {@html $_('footer.disclaimer')}
        </div>
    </div>
</footer>